import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaFonteDeiDatiEditComponent.vue?vue&type=template&id=0592a203"
import script from "./RsaSchedaRelazioneSanitariaFonteDeiDatiEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaFonteDeiDatiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports